<div class="group-flag-wrapper" [class.has-gap]="!isCollapsed">
    <div class="flag-group-title">
        <div class="group-header-wrapper">
            <div class="group-name-wrapper">
                <h3 class="subtitle group-title-wrapper" (click)="toggleCollapsed()">
                    <span *ngIf="isGroupModified" class="group-dot" appTooltip
                        text="One or more flags in this group have been modified."></span>
                    {{ groupName }}
                    <ng-container *ngIf="isFullAdmin">
                        ({{ flagCount }})
                    </ng-container>
                </h3>
                <core-toggle *ngIf="!isToggleDisabled" class="group-toggle" label="" [checked]="isGroupEnabled"
                    (onChange)="onToggleGroup()" />
            </div>
            <div class="toggle-button-wrapper" *ngIf="isFullAdmin" (click)="toggleCollapsed()">
                <div class="toggle-button">
                    <app-chevron-icon color="#000000" width="20px" height="15px"
                        [direction]="isCollapsed ? 'down' : 'up'" />
                </div>
            </div>
        </div>
        <p class="group-description" *ngIf="groupDescription">{{ groupDescription }}</p>
    </div>
    <ng-container *ngIf="isFullAdmin">
        <div class="flags-collapsible-wrapper" [class.collapsed]="isCollapsed">
            <ng-container *ngFor="let key of flagKeys">
                <app-flag *ngIf="!isFlagMissing(key)" [key]="key" [modified]="isFlagModified(key)"
                    [active]="isFlagActive(key)" [helpText]="flagHelpMapping[key]"
                    (toggled)="onToggleFlag(key)"></app-flag>
            </ng-container>
        </div>
    </ng-container>
</div>